import { getFile } from '../../../services/storage-service';
import { useChatStore } from '../../../state/store/chat/use-chat-store';
import { useEffect, useState } from 'react';
import { useConfig } from 'hooks/use-config';

interface ImagePreviewProps {
  itemId: string;
}

export const ImagePreview = ({ itemId }: ImagePreviewProps) => {
  const itemIdFilePathMap = useChatStore((state) => state.itemIdFilePathMap);
  const setItemIdFilePathMap = useChatStore((state) => state.setItemIdFilePathMap);
  const [isLoading, setIsLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const { configurationSettings } = useConfig();

  useEffect(() => {
    const fetchImage = async () => {
      if (!itemId) return;

      const filePath = itemIdFilePathMap.get(itemId);
      if (filePath) {
        setImageSrc(filePath);
        return;
      }

      setIsLoading(true);
      try {
        const response = await getFile(itemId, configurationSettings, undefined);
        if (response.isSuccess && response.url) {
          setImageSrc(response.url);
          setItemIdFilePathMap(itemId, response.url);
        }
      } catch (error) {
        // Error occurred, imageSrc will remain empty which will show "No image found"
        console.error('Failed to fetch image:', error);
      }
      setIsLoading(false);
    };

    fetchImage();
  }, [itemId]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!imageSrc) {
    return <div>No image found</div>;
  }

  return (
    <div>
      <img className="w-96 h-48 object-contain" src={imageSrc} alt="" />
    </div>
  );
};
